const fileManagerRoute = window.api_routes.smarAPD_FileManager_Domain;

export default {
  openReport(result) {
    if (result.data.Success) {
      const destino = '_blank';
      window.open(
        `${fileManagerRoute}/FileManager/TB/DownloadReportTB?fileName=${result.data.FileName}&viewInBrowser=true`,
        destino
      );
    } else _alert.error(result.data.Error);
  },
  validLinkReport(link) {
    if (isValidHttpUrl(link)) {
      if (link.includes('DownloadReportTB')) {
        let reportUrl = new URL(link);
        return `${fileManagerRoute}/FileManager/TB/DownloadReportTB${reportUrl.search}`;
      } else return link;
    }
  }
};

export function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
};
